import React, { useState } from 'react';
import { Row, Col, Form, Input, Label } from 'reactstrap';
import { AccountDetailData } from '../../types/types';
import DescriptionModal from '../modals/DescriptionModal';

interface AccountDetailProps {
  accountDetailData: AccountDetailData;
  setAccountDetailData: (data: AccountDetailData) => void;
}

const AccountDetail: React.FC<AccountDetailProps> = ({ accountDetailData, setAccountDetailData }) => {
  const [isDescriptionModalOpen, setIsDescriptionModalOpen] = useState(false);

  const handleCommentsChange = (value: string) => {
    setAccountDetailData({ ...accountDetailData, comments: value });
  };

  const handleSearchClick = () => {
    setIsDescriptionModalOpen(true);
  };

  const handleDescriptionSave = (description: string) => {
    setAccountDetailData({ ...accountDetailData, comments: description });
    setIsDescriptionModalOpen(false);
  };

  const handleDescriptionModalClose = () => {
    setIsDescriptionModalOpen(false);
  };

  return (
    <>
      <fieldset className="border p-2">
        <legend className="float-none w-auto px-2 mb-0 text-body" style={{ fontSize: '0.9rem' }}>Account Detail</legend>
        <Form>
          <Row>
            <Col md={12}>
              <div className="mb-3">
                <Label htmlFor="comments" className="form-label mb-0">
                  Comments
                </Label>
                <div className="d-flex">
                  <Input
                    type="textarea"
                    className="form-control"
                    id="comments"
                    value={accountDetailData.comments}
                    onChange={(e) => handleCommentsChange(e.target.value)}
                    rows={8}
                    style={{ resize: 'vertical' }}
                  />
                  <button
                    className="btn btn-light btn-sm ms-2 align-self-start"
                    type="button"
                    onClick={handleSearchClick}
                  >
                    <i className="ri-search-line"></i>
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Form>
      </fieldset>

      {/* Description Modal */}
      <DescriptionModal
        isOpen={isDescriptionModalOpen}
        onClose={handleDescriptionModalClose}
        onSave={handleDescriptionSave}
        initialValue={accountDetailData.comments}
      />
    </>
  );
};

export default AccountDetail; 